import { render, staticRenderFns } from "./Orginforject.vue?vue&type=template&id=c83e234e&scoped=true"
import script from "./Orginforject.vue?vue&type=script&lang=js"
export * from "./Orginforject.vue?vue&type=script&lang=js"
import style0 from "./Orginforject.vue?vue&type=style&index=0&id=c83e234e&prod&scoped=true&lang=css"
import style1 from "./Orginforject.vue?vue&type=style&index=1&id=c83e234e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83e234e",
  null
  
)

export default component.exports